module.exports = __webpack_public_path__ + "media/appendiceal tumor.0496adbe.wav";